import { tv } from 'tailwind-variants';

export const variantsCarouselStyles = tv({
  base: `
    w-full

    cursor-grabbing
    select-none
  `,
  slots: {
    viewport: `
      overflow-hidden
    `,
    container: `
      flex
      gap-2
    `,
  },
});
